module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalConfirmation', {
    attrs: {
      "isShowConfirmDeleteMessage": false,
      "appendToBody": true,
      "customWidth": "420px",
      "ariaLabel": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('template', {
    slot: "custom_warning"
  }, [_c('p', {
    staticClass: "onward-confirm__intro"
  }, [_vm._v(_vm._s(_vm.applyOnwardsText))]), _vm._v(" "), _c('div', {
    staticClass: "onward-confirm__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEndDate.apply(null, arguments)
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "propOn": _vm.hasEndDate,
      "allowChanges": false
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n.choose_end_date))])], 1), _vm._v(" "), (_vm.hasEndDate) ? _c('div', {
    staticClass: "onward-confirm__date"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.enddate,
      "minDate": _vm.minDate,
      "width100": true
    },
    on: {
      "changed": _vm.setEndDate
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.cancel))]), _vm._v(" "), _c('button', {
    staticClass: "bttn",
    class: {
      'bttn-danger': _vm.mode === 'remove'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.confirmLabel) + "\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fd39edd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarViewDayOnwardConfirm.vue
// module id = 1952
// module chunks = 1